import { useState, useEffect } from 'react';
import logo from '../../images/logo.png'
import './signup.css';
import { Button, Layout, Form, Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Content } from "antd/lib/layout/layout";
import PasswordChecklist from "react-password-checklist"

const { Header } = Layout;

interface User {
    "email": string,
    "username": string,
    "password": string,
    "re_password": string
}

interface SignUpProps {
    requestUrl: string
}


const SignUp: React.FC<SignUpProps> = ( { requestUrl } ) => {
    const [newUser, setNewUser] = useState<User | undefined>(undefined)
    const [password, setPassword] = useState("")
    const navigate = useNavigate()



    const onFinish = (values: {email: string, password: string}) => {
        setNewUser({
            "email": values.email,
            "username": values.email,
            "password": values.password,
            "re_password": values.password
        })
    };

    useEffect(() => {
        if(newUser) {
            const requestOptions = {
                method: 'POST',
                headers : {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newUser)
            }

            fetch(`${requestUrl}/auth/users/`, requestOptions)
                .then(response => {
                    switch (response.status) {
                        case 201:
                            navigate('/login')
                            message.success('Account created.')
                            break;
                        case 400:
                            message.warning('Email and/or password does not meet requirements')
                            break;
                    }
                })
        }
    }, [newUser, requestUrl, navigate])
      
    /////// Any? //////
      const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
      };

    return(
        <Layout className="site-layout-background">
            <Header className="header navbar-layout-background" >
                <div className='navbar-content'>
                    <div className='logo-area'>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <img className='logo' alt='logo' src={logo} />
                        </Link>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <h1>FairVote</h1>
                        </Link>
                    </div>
                    <div className='button-area'>
                        <p className='sign-up-switch'>Have an Account?</p>
                        <Link to='/login' style={{ textDecoration: 'none' }}>
                            <Button type="primary">
                                Log In
                            </Button>
                        </Link>  
                    </div>
                </div>
            </Header>
            <Content className='page_content_card'>
                <div className='page_content'>
                    <div className='left_col'>
                        <div className='greet'>
                            <p className='welcome'>Welcome to Fairvote</p>
                            <p className='sign_up'>Sign Up to get started!</p> 
                        </div>
                    </div>
                    <div className='right_col'>
                        <div className='right_col_inner'>
                            <Form
                                name="basic"
                                wrapperCol={{
                                    span: 24,
                                }}
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off" >
                                
                                <Form.Item
                                    name="email"
                                >
                                    <Input type='email' placeholder="E-mail" />
                                </Form.Item>

                                <Form.Item
                                    name="password"
                                >
                                    <Input.Password type='password' placeholder="Password" onChange={e => setPassword(e.target.value)}/>
                                    
                                </Form.Item>

                                <Form.Item>
                                    <PasswordChecklist
                                        rules={["minLength"]}
                                        minLength={15}
                                        value={password}
                                        messages={{
                                            minLength:'Minimum 15 characters in length'
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    wrapperCol={{
                                    offset: 0,
                                    span: 24,
                                    }}>
                                    <Button block type="primary" htmlType="submit">
                                    Sign Up
                                    </Button>
                                </Form.Item>
                                <p>
                                    By clicking Sign Up, you agree to our Terms.
                                </p>
                            </Form>
                        </div>
                    </div>   
                </div>                             
            </Content>
        </Layout>
    )
};

export default SignUp;